import { connect } from 'react-redux'
import Comment from '../components/Comment'
import { getAccountProfile } from '../reducers/accountReducer'

const mapStateToProps = ({ account }) => ({
  accountProfile: getAccountProfile(account),
})

export default connect(mapStateToProps)(Comment)
